<template>
  <div>
    <ToolbarMy />
    <v-container class="py-8">
      <v-row>
        <v-col cols="12" xs="12" sm="5" md="5" lg="5" class="d-md-block">
          <v-img class="rounded-lg" :aspect-ratio="$vuetify.breakpoint.lgAndDown ? 1 : 1" :src="require('@/assets/images/whs.jpg')" alt="">
          </v-img>
        </v-col>
        <v-col cols="12" xs="12" sm="7" md="7" lg="7" class="ml-sm-0 mr-sm-0 pl-sm-0 pr-sm-0 pl-md-3 pr-md-3">
          <v-flex class="text-sm-h6 text-md-h4 mt-xl-4 font-weight-bold">About</v-flex>
          <v-flex class="mt-xl-4 pt-3">This is Wei-Hsiang Shen (Tommy Shen), a second year PhD student in the <span class="font-weight-bold">Department of Electrical Engineering</span> (EE) at <span class="font-weight-bold">National Tsing Hua University</span> (NTHU), Hsinchu, Taiwan. Also, interning at the <span class="font-weight-bold">AI algorithm team</span> (IP camera) at Realtek corp, Hsinchu.</v-flex>
          <v-flex class="mt-xl-4 pt-3">My research interests include <span class="font-weight-bold">computer vision</span>, <span class="font-weight-bold">image processing</span> and <span class="font-weight-bold">ultrasound imaging</span>, focusing on improving the image quality of natural and ultrasound images. I am currently at <a href="https://www.ee.nthu.edu.tw/~mlli/index.html" target="_blank">Biophotonic and Ultrasonic Imaging Lab</a> and advised by Prof. <a href="https://www.ee.nthu.edu.tw/~mlli/people.html" target="_blank">Meng-Lin Li</a>.</v-flex>
          <v-flex class="mt-xl-4 pt-3">I founded a startup <a href="https://lepus.fi/" target="_blank">Lepus Finance</a> that help manage users' cryptocurrency assets and create profit for them. I actively research on <span class="font-weight-bold">decentralized finance</span> (DeFi) and develop yeild farming strategies.</v-flex>

          <!-- <v-flex class="text-sm-h6 text-md-h4 mt-xl-4 font-weight-bold pt-4">For undergraduate students</v-flex>
          <v-flex class="mt-xl-4 pt-3">I am looking for undergraduate students for NTHU EE projects implementation (實作專題). If you are interested in image processing or computer vision for medical images, please let me know!</v-flex> -->
        </v-col> 
      </v-row>
      
    </v-container>
    <v-sheet>
      <v-container class="py-4 py-lg-5">
        <v-flex text-center pb-5 display-1>Contacts</v-flex>

        <v-flex class="text-sm-h6 text-md-h5 mt-xl-4 font-weight-bold">For undergraduate students,</v-flex>
        <v-flex pt-1 pb-4>If you are interested in image processing or ultrasound imaging, and is searching for NTHU EE projects implementation (實作專題) topcis, feel free to visit <a href="https://www.ee.nthu.edu.tw/~mlli/index.html" target="_blank">Biophotonic and Ultrasonic Imaging Lab</a> or contact Prof. <a href="https://www.ee.nthu.edu.tw/~mlli/people.html" target="_blank">Meng-Lin Li</a> directly!.</v-flex>

        <v-flex class="text-sm-h6 text-md-h5 mt-xl-4 font-weight-bold">For researchers,</v-flex>
        <v-flex pt-1 pb-4>Extremely willing to cowork and publish with other PhD students or postdocs on computer vision or imaging processing research topics. My published papers could be check at <a href="https://scholar.google.com/citations?hl=zh-TW&authuser=1&user=VsIrznEAAAAJ" target="_blank">Google Scholar</a>. Currently I am interested in deep learning based image processing/enhancement on natural images and medical images.</v-flex>

        <v-flex class="text-sm-h6 text-md-h5 mt-xl-4 font-weight-bold">For blockchain devs & entrepreneurs,</v-flex>
        <v-flex pt-1 pb-4>More than happy to chat and connect with all the blockchain people! Please let me know if you are interested in my company Rabbit Helper or other DeFi topcis. We would probably have a angel round in the near future.</v-flex>
      </v-container>
    </v-sheet>
    <!-- <v-sheet> -->
      <v-container class="py-4 py-lg-5">
        <v-flex text-center pb-5 display-1>Selected Publications</v-flex>
        <v-row>
          <v-col cols="12" md="6" xl="4">
            <v-card outlined>
              <v-img :src="require('@/assets/images/pca_motion_mag2.gif')" aspect-ratio="2.2"></v-img>
              <v-responsive class="mx-auto pa-2">
                <div class="">Principle-Component-Analysis Based Motion Magnification for B-mode Visualization of Magnetomotive Ultrasound</div>
                <div class="text--secondary pt-1"><span class="text-decoration-underline ">Wei-Hsiang Shen</span>, Meng-Lin Li</div>
                <div class="text--secondary">IEEE International Ultrasonics Symposium (IUS) 2019</div>
                <div class="">[<a target="_blank" href="https://ieeexplore.ieee.org/abstract/document/8926060">paper</a>]</div>
              </v-responsive>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" xl="4">
            <v-card outlined>
              <v-img :src="require('@/assets/images/realtime_MMUS.png')" aspect-ratio="2.2"></v-img>
              <v-responsive class="mx-auto pa-2">
                <div class="">Toward Real Time Backward-Mode Pulsed Magnetomotive Ultrasound</div>
                <div class="text--secondary pt-1"><span class="text-decoration-underline ">Wei-Hsiang Shen</span>, Meng-Lin Li</div>
                <div class="text--secondary">IEEE International Ultrasonics Symposium (IUS) 2019</div>
                <div class="">[<a target="_blank" href="https://ieeexplore.ieee.org/abstract/document/8926244">paper</a>]</div>
              </v-responsive>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <!-- </v-sheet> -->
    <!-- <HeroMy /> -->
    <!-- <FeatureMy /> -->
    <!-- <Hero2Demo />
    <Logos2Demo />
    <Feature11Demo />
    <Team6Demo />
    <CallToAction5Demo />
    <Footer4Demo /> -->
  </div>
</template>

<script>
import ToolbarMy from '@/components/ui/landing/toolbar/ToolbarMy.vue'
import HeroMy from '@/components/ui/landing/hero/HeroMy.vue'
import FeatureMy from '@/components/ui/landing/feature/FeatureMy.vue'
// import Hero2Demo from '@/components/ui/landing/hero/Hero2Demo.vue'
// import Logos2Demo from '@/components/ui/landing/logos/Logos2Demo.vue'
// import Feature11Demo from '@/components/ui/landing/feature/Feature11Demo.vue'
// import CallToAction5Demo from '@/components/ui/landing/call-to-action/CallToAction5Demo.vue'
// import Footer4Demo from '@/components/ui/landing/footer/Footer4Demo.vue'
// import Team6Demo from '@/components/ui/landing/team/Team6Demo.vue'

export default {
  components: {
    ToolbarMy,
    HeroMy,
    FeatureMy
    // CallToAction5Demo,
    // Feature11Demo,
    // Footer4Demo,
    // Team6Demo
  }
}
</script>
